import React, { PureComponent } from 'react'
import { Menu, Icon } from 'antd'
import { Link } from 'react-router-dom'

const SubMenu = Menu.SubMenu
const MenuItemGroup = Menu.ItemGroup

export class RepairJobMenu extends PureComponent {
  getURL = itemKey => {
    const { jobId, jobType } = this.props.match.params
    return `/jobView/${jobId}/${jobType}/${itemKey}`
  }
  render() {
    return (
      <Menu
        onClick={this.props.handleClick}
        selectedKeys={[this.props.currentKey]}
        mode={this.props.screenWidth > 900 ? 'horizontal' : 'inline'}
      >
        <SubMenu
          title={
            <span>
              <Icon type="profile" />Details
            </span>
          }
        >
          <MenuItemGroup title="Job Details">
            <Menu.Item key="Job Attachments">
              <Link to={this.getURL('attachments')}>Attachments</Link>
            </Menu.Item>{' '}
            <Menu.Item key="Job Follow Ups">
              <Link to={this.getURL('follow-ups')}>Follow Ups</Link>
            </Menu.Item>
            <Menu.Item key="Job Notes">
              <Link to={this.getURL('notes')}>Notes</Link>
            </Menu.Item>
          </MenuItemGroup>
        </SubMenu>
        <Menu.Item key="Job Contacts">
          <Link to={this.getURL('contacts')}>
            <Icon type="message" />Contacts
          </Link>
        </Menu.Item>
        <Menu.Item key="Repair Schedule">
          <Link to={this.getURL('schedule-repair')}>
            <Icon type="calendar" />Schedule
          </Link>
        </Menu.Item>
        <SubMenu
          title={
            <span>
              <Icon type="book" />Financials
            </span>
          }
        >
          <MenuItemGroup title="Job Financials">
            <Menu.Item key="Job Financial Summary">
              <Link to={this.getURL('financial-summary')}>Financial Summary</Link>
            </Menu.Item>
            <Menu.Item key="Job Payment Requests">
              <Link to={this.getURL('payment-requests')}>Payment Requests</Link>
            </Menu.Item>
            <Menu.Item key="Job Agreements">
              <Link to={this.getURL('agreements')}>Agreements</Link>
            </Menu.Item>
            <Menu.Item key="Job Invoices">
              <Link to={this.getURL('invoices')}>Invoices</Link>
            </Menu.Item>
          </MenuItemGroup>
        </SubMenu>
        <Menu.Item key="Job Vendors">
          <Link to={this.getURL('vendors')}>
            <Icon type="shop" />Vendors
          </Link>
        </Menu.Item>
        <Menu.Item key="Job Parts">
          <Link to={this.getURL('parts')}>
            <Icon type="setting" />Parts
          </Link>
        </Menu.Item>
        <Menu.Item key="Job Stop Calls">
          <Link to={this.getURL('stop-calls')}>
            <Icon type="close-circle-o" />Stop Calls
          </Link>
        </Menu.Item>
        <SubMenu
          title={
            <span>
              <Icon type="solution" />DOB/Violations
            </span>
          }
        >
          <MenuItemGroup title="DOB">
            <Menu.Item key="DOB Attachments">
              <Link push to={this.getURL('dob-attachments')}>
                Attachments
              </Link>
            </Menu.Item>
            <Menu.Item key="Violations">
              <Link to={this.getURL('violations')}>Violations</Link>
            </Menu.Item>
            <Menu.Item key="DOB Notes">
              <Link to={this.getURL('dob-notes')}>Notes</Link>
            </Menu.Item>
            <Menu.Item key="Testing">
              <Link to={this.getURL('testing')}>Testing</Link>
            </Menu.Item>
          </MenuItemGroup>
        </SubMenu>
        <SubMenu
          title={
            <span>
              <Icon type="environment" />Job Site
            </span>
          }
        >
          <MenuItemGroup title="Job Site Management">
            <Menu.Item key="Job Site Overview">
              <Link to={this.getURL('site-overview')}>Overview</Link>
            </Menu.Item>{' '}
            <Menu.Item key="Job Site Tickets">
              <Link to={this.getURL('site-tickets')}>Tickets</Link>
            </Menu.Item>
            <Menu.Item key="Job Site Driver Requests">
              <Link to={this.getURL('driver-requests')}>Driver Requests</Link>
            </Menu.Item>{' '}
            <Menu.Item key="Job Site Material Requests">
              <Link to={this.getURL('material-requests')}>Material Requests</Link>
            </Menu.Item>
            <SubMenu title={<span>Repair Orders</span>}>
              <Menu.Item key="Job Site Estimates">
                <Link to={this.getURL('site-estimates')}>Estimates</Link>
              </Menu.Item>{' '}
              <Menu.Item key="Job Site Repair Orders">
                <Link to={this.getURL('repair-orders')}>Repair Orders</Link>
              </Menu.Item>
            </SubMenu>
            <Menu.Item key="Job Site Service Orders">
              <Link to={this.getURL('service-orders')}>Service Orders</Link>
            </Menu.Item>
            <Menu.Item key="Job Site Documents">
              <Link to={this.getURL('site-documents')}>Documents</Link>
            </Menu.Item>{' '}
          </MenuItemGroup>
        </SubMenu>
      </Menu>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/RepairJobMenu.js